<styles-smart-table
  #smartTable
  [datasource]="users"
  [mainColumns]="buildMainColumns()"
  [showColumnHeaders]="showColumnHeaders"
>
  <ng-container matColumnDef="spaceName">
    <td mat-cell *matCellDef="let element" [attr.colspan]="2">
      <div class="container">
        <mat-icon class="color-icon"> corporate_fare </mat-icon>
        {{$any(element)?.name }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="title">
    <th mat-header-cell *matHeaderCellDef>Name</th>
    <td mat-cell *matCellDef="let element">
      <div class="title-alignment">
        <framework-person-image [person]="element" size="30px" *ngIf="element"></framework-person-image>

        <div>
          <div class="title ellipsis-text">{{ $any(element).name }}</div>
          <div class="sub-title"></div>
          <div class="ellipsis-text">{{ $any(element)?.email }}</div>
        </div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="groups">
    <th mat-header-cell *matHeaderCellDef>Extra Groups</th>
    <td mat-cell *matCellDef="let element">
      <ng-container *ngFor="let g of removeStandardGroups(element)">{{g.name}}, </ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="role">
    <th mat-header-cell *matHeaderCellDef>Role</th>
    <td mat-cell *matCellDef="let element">{{ $any(element)?.permission?.name }}</td>
  </ng-container>

  <ng-container matColumnDef="lastLogin">
    <th mat-header-cell *matHeaderCellDef>Last Login</th>
    <td mat-cell *matCellDef="let element">{{ $any(element)?.lastLogin | date : 'medium' }}</td>
  </ng-container>

  <ng-container matColumnDef="profileId">
    <th mat-header-cell *matHeaderCellDef>ProfileId</th>
    <td mat-cell *matCellDef="let element">{{ $any(element)?.id }}</td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>Email</th>
    <td mat-cell *matCellDef="let element">
      <div class="task-box">{{ $any(element)?.email }}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="state">
    <th mat-header-cell *matHeaderCellDef>State</th>
    <td mat-cell *matCellDef="let element">
      <div class="task-box">{{ $any(element)?.state }}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <div class="task-box">
        <button styles-button (click)="editUserModal(element)" [disabled]="element.state !== 'Registered'">
          <mat-icon>edit</mat-icon>
          Edit
        </button>
        <framework-action-dropdown
          [project]="$any(element)"
          [masterProject]="$any(organization)"
          location="admin"
          [actions]="getActionDataDynamic(element)"
          level="other"
        >
        </framework-action-dropdown>
      </div>
    </td>
  </ng-container>
</styles-smart-table>
